function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

// @ts-check
import Vue from 'vue';
import template from './nullable-input.html';

var NullableInput = /*#__PURE__*/function () {
  function NullableInput() {
    _classCallCheck(this, NullableInput);
  }

  _createClass(NullableInput, null, [{
    key: "register",
    value: function register() {
      Vue.component('roche-nullable-input', {
        template: template,
        props: {
          labels: {
            type: Object
          },
          allowNull: {
            type: Boolean
          },
          required: {
            type: Boolean
          },
          rules: {
            type: Object
          },
          pattern: {
            type: String
          },
          type: {
            type: String
          },
          disabledNoCheck: {
            type: Boolean
          },
          formValue: {
            type: String
          },
          formValueUnknown: {
            type: Boolean
          },
          cypressClass: {
            type: String
          }
        },
        computed: {},
        data: function data() {
          return {
            inputValue: this.formValue,
            checkboxValue: this.formValueUnknown || false
          };
        },
        watch: {
          inputValue: function inputValue(newValue) {
            this.$emit('update:formValue', newValue);
          },
          formValue: function formValue(newValue) {
            this.inputValue = newValue;
          },
          checkboxValue: function checkboxValue(newBooleanValue) {
            this.$emit('update:formValueUnknown', newBooleanValue);
          },
          formValueUnknown: function formValueUnknown(newBooleanValue) {
            this.checkboxValue = newBooleanValue;
          }
        }
      });
    }
  }]);

  return NullableInput;
}();

export default NullableInput;